import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-content">
        <div className="section-header">
          <h2 className="section-title">Let's Work Together</h2>
        </div>
        <p>
          Ready to bring your next project to life? I'd love to hear about your ideas, 
          challenges, and vision. Let's create something amazing together.
        </p>

        <div className="contact-buttons">
          <a href="mailto:chittoorharish989@gmail.com" className="contact-btn">
            📧 Send Email
          </a>
          <a href="https://www.linkedin.com/in/harish-chittoor/" target="_blank" rel="noopener noreferrer" className="contact-btn">
            💼 LinkedIn
          </a>
          <a href="https://github.com/ChittoorHarish" target="_blank" rel="noopener noreferrer" className="contact-btn">
            💻 GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
